goog.provide('yext.storm.linkedaccounts');
goog.provide('yext.storm.linkedaccounts.SaveLinkedAccountForm');

/** @suppress {extraRequire} */
goog.require('yext.plugins.inputchange');
/** @suppress {extraRequire} */
goog.require('yext.plugins.locationPicker');
goog.require('yext.plugins.ActionMenu');
/** @suppress {extraRequire} */
goog.require('yext.storm.FolderTree');
goog.require('yext.storm.routesDEPRECATED');

(function() {
  /**
   * @constructor
   */
  var SaveLinkedAccountForm = function() {
    this.bindRadioSelection();
    this.bindLocationSearcher();
    this.bindInputChange();
    this.bindErrorBox();
    this.bindActionMenus();
    this.bindLinkGmbAccountButton();
  };
  goog.exportSymbol('SaveLinkedAccountForm', SaveLinkedAccountForm);

  SaveLinkedAccountForm.prototype.bindRadioSelection = function() {
    $('form#save-linkedaccount-form input:radio').click(function() {
      if ($(this).hasClass('select-folder')
          && $('.save-linkedaccount-folder-container').find('.dynatree-container').length === 0) {
        setupTree();
        $('.save-linkedaccount-location-select').hide();
      } else if ($(this).hasClass('select-folder')) {
        $('.save-linkedaccount-folder-container').show();
        $('.save-linkedaccount-location-select').hide();
      } else if ($(this).hasClass('select-location')) {
        $('.save-linkedaccount-folder-container').hide();
        $('.save-linkedaccount-location-select').show();
      } else {
        $('.save-linkedaccount-location-select').hide();
        $('.save-linkedaccount-folder-container').hide();
      }
    });
  };

  SaveLinkedAccountForm.prototype.bindLocationSearcher = function() {
    $('.save-linkedaccount-location-select > select').locationPicker(
      null, null, {permissionIds: $('input[name="locationSearchPermission"]').val()});
    $('.chosen-container').css('width', '380px');
    $('.chosen-drop').css('width', '378px');
  };

  function setupTree() {
    $('.save-linkedaccount-folder-container').simpleFolderTree({
      'title': 'Save Linked Account Create List Tree',
      'topLevelFolders': window.topLevelFolders,
      'idPrefix': 'save-linkedaccount-tree-id-',
      'onActivate': function(node) {
        $('input[name="folderId"]').val(node.data.key).trigger('change');
      },
    });
  }

  SaveLinkedAccountForm.prototype.bindInputChange = function() {
    $('form#save-linkedaccount-form input, .save-linkedaccount-location-select > select').inputchange(function() {
      var validInput = true;

      if ($('input:checked').hasClass('select-folder')
          && $('input[name="folderId"]').val().length === 0) {
        validInput = false;
      }

      if ($('input:checked').hasClass('select-location')
          && $('select[name="locationId"]').val().length === 0) {
        validInput = false;
      }

      if (validInput && $('form#save-linkedaccount-form input:checked').length) {
        $('form#save-linkedaccount-form .primary').removeClass('disabled');
      } else {
        $('form#save-linkedaccount-form .primary').addClass('disabled');
      }
    });
  };

  SaveLinkedAccountForm.prototype.bindErrorBox = function() {
    $('.js-linked-accounts-error .js-error-dismiss').on('click', function() {
      $(this).closest('.js-linked-accounts-error').hide();
    });
  };

  SaveLinkedAccountForm.prototype.bindActionMenus = function() {
    $('.js-linked-account-action-menu').each(function() {
      yext.plugins.ActionMenu.initialize($(this));
    });
  };

  SaveLinkedAccountForm.prototype.bindLinkGmbAccountButton = function() {
    $('.js-link-yext-gmb-account').click(function() {
      window.location = yext.storm.routesDEPRECATED.LinkedAccounts.linkYextGmbAccount();
    });
  };
})();

